import { BIND_TYPE, FIELD_VALUE_TYPE } from '@constants'

export enum FIELD_TYPE {
  SINGLE = 'single',
  OBJECT_LINK = 'object_link',
}

export type SortDirection = 'asc' | 'desc' | null

export type CurrentSortParams = {
  columnToSort: string
  sortDirection: SortDirection
  priority: number
}

/** Модель для отрисовки окна с конфигурацией табличного представления */
export type ObjectWithConfiguredRestrictions = {
  /** Заголовок объекта */
  objectTitle: string
  /** Код объекта */
  objectCode: string
  /** Список колонок объекта с ограничениями для отрисовки окна конфигурации */
  columns: ColumnWithConfiguredRestrictions[]
}

/** Колонка в конфигурации табличного представления */
export type ColumnWithConfiguredRestrictions = {
  /** Активация колонки */
  enabled: boolean
  /** Наименование поля */
  field: string
  /** Описание поля */
  desc: string
  /** Тип поля */
  type: FIELD_TYPE
  /** Базовая обязательность поля */
  baseRequired: boolean
  /** Выставленная пользовательская обязательность */
  userRequired: boolean
  /** Уникальность */
  unique: boolean
  /** Ограничение по символам */
  symbolsNumLimit: number | null
  /** Список вложенных полей, если текущее поле является ссылочным */
  embeddedFields: ConfiguredColumnEmbeddedField[] | null
}

/** Вложенное поле для ссылочного поля в конфигурации табличного представления  */
export type ConfiguredColumnEmbeddedField = {
  /** Наименование вложенного поля */
  name: string
  /** Активация колонки вложенного поля */
  enabled: boolean
}

/** Перечисление типов ограничения  */
export enum RESTRICTION_TYPE {
  /** Сортировка поля */
  SORT = 'SORT',
  /** Отображение колонки с данным полем у пользователя */
  SHOW = 'SHOW',
  /** Ширина колонки с данным полем у пользователя */
  WIDTH = 'WIDTH',
  /** Порядок колонки с данным полем в таблице у пользователя */
  ORDER = 'ORDER',
  /** Закрепление колонки справа/слева в таблице у пользователя */
  FIX = 'FIX',
  /** Разрешаем быстрый поиск для этой колонки */
  QUICK_SEARCH_PERMISSION = 'QUICK_SEARCH_PERMISSION',
  /** Дефолтное значение чекбокса быстрого поиска */
  QUICK_SEARCH_CHOICE = 'QUICK_SEARCH_CHOICE',
}

/** Модель ограничения */
export type RestrictionDTO = {
  /** Наименование родительского поля при наличии */
  parentFieldName?: string | null
  /** Наименование поля */
  fieldName: string
  /** Код колонки */
  fieldCode: string
  /** id вью */
  viewId: string | number
  /** Тип ограничения */
  restrictionType: RESTRICTION_TYPE
  /** Значение ограничения */
  value: unknown
}

export type ApiRestrictionData = {
  sort: CutRestrictionDTO[]
  order: CutRestrictionDTO[]
  fix: CutRestrictionDTO[]
  show: CutRestrictionDTO[]
  width: CutRestrictionDTO[]
  quick_search_choice: CutRestrictionDTO[]
  quick_search_permission: CutRestrictionDTO[]
}

export const RESTRICTION_TYPE_TO_KEY: Record<RESTRICTION_TYPE, keyof RestrictionData> = {
  [RESTRICTION_TYPE.SORT]: 'sort',
  [RESTRICTION_TYPE.ORDER]: 'order',
  [RESTRICTION_TYPE.FIX]: 'fix',
  [RESTRICTION_TYPE.SHOW]: 'show',
  [RESTRICTION_TYPE.WIDTH]: 'width',
  [RESTRICTION_TYPE.QUICK_SEARCH_CHOICE]: 'quickSearchChoice',
  [RESTRICTION_TYPE.QUICK_SEARCH_PERMISSION]: 'quickSearchPermission',
}

export type RestrictionKey =
  | 'sort'
  | 'show'
  | 'width'
  | 'order'
  | 'fix'
  | 'quickSearchChoice'
  | 'quickSearchPermission'

export type CutRestrictionDTO = Omit<RestrictionDTO, 'objectCode' | 'restrictionType' | 'viewCode'>

export type RestrictionData = Record<RestrictionKey, CutRestrictionDTO[]>

export type SortRestriction = {
  columnToSort: string
  priority: number
  sortDirection: 'asc' | 'desc'
}

export type OrderRestriction = {
  value: string
}

export type WidthRestriction = {
  value: number
}

export type QSRestriction = {
  value: boolean | string
}

export type ShowRestriction = {
  value: boolean | string
}

export type FixRestriction = {
  value: string
}

export type FormattedColumnRestrictions = {
  bindType: BIND_TYPE
  fieldCode: string
  fieldName: string
  value: string
  objectValue: string | null
  valueType: FIELD_VALUE_TYPE
  order?: OrderRestriction
  width?: WidthRestriction
  sort?: SortRestriction
  quickSearchChoice?: QSRestriction
  quickSearchPermission?: QSRestriction
  fix?: FixRestriction
  show?: ShowRestriction
}
